<confirm-noft>
  <div class="wrap wrap02">
    <h1><img class="logo" src="/service_lp/img/logo.png" alt="BeatFit" /></h1>
    <img class="step" src="/service_lp/img/confirm.png" alt="step02" />

    <p><strong>必ず現在課金をしていないかをご確認ください。</strong></p>
    <p class="registration-notes">
      ・課金状態がわからないかたやご不明点がある方は、下記のお問い合わせ先までご連絡ください。<br />
      ・決済のローディング中に他のページに遷移したり、更新したりすると、正しく決済の処理ができない可能性がございます。<br />
      ・数分経過しても画面が変わらない場合にも下記のお問い合わせまでご連絡ください。<br />
      ・決済のローディング中に他のページに遷移したり更新をしたりすると正しく決済の処理ができない可能性があります。<br />
      ・少々このままでお待ち下さい。数分経過しても画面が変わらない場合、下記のお問い合わせ先までご連絡ください。<br />
      お問合せ先 : 「<a href="mailto:support@beatfit.jp">support@beatfit.jp</a>」<br />
    </p>
    <br />
    <button class="next" type="button" onClick={ registration }><img src="/service_lp/img/ok.png" alt="OK" /></button>
  </div>

  <script>
    var self = this

    registration(e) {
      activeLoading('このまま少々お待ち下さい。 ローディング中にページの更新や他ページへの遷移はご遠慮ください。')
      requestServerByPromise('/api/v2/user/web_registration_noft', 'POST', { key: opts.hash_key }).then((response) => {
        passiveLoading()
        if(!response.result) {
          return window.error('登録に失敗しました', response)
        } else {
          location.href = generateRedirectUrl()
        }
      }).catch((error) => {
        return window.error('登録に失敗しました', error)
      })
    }
  </script>

  <style>
  .registration-notes {
    text-align: left;
    font-size: 0.7em;
  }
  </style>
</confirm-noft>
